import React from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import Timestamp from '../../../Timestamp';
import s from './PublishedTime.scss';
const PublishedTime = ({ publishedTime, withoutText, className, isPublished })=>{
    const { t } = useTranslation();
    if (!publishedTime && !isPublished) {
        return /*#__PURE__*/ React.createElement("span", {
            className: classnames(s['root'], className)
        }, t('deviation.details.notPublished'));
    }
    if (!publishedTime) {
        return null;
    }
    const timestamp = /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: publishedTime,
        showTooltip: true,
        showFullLengthOnMobile: true
    });
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['root'], className)
    }, withoutText ? timestamp : /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: 'deviation.details.publishedTime'
    }, "Published: ", timestamp));
};
PublishedTime.displayName = 'PublishedTime';
export default PublishedTime;
